<template>
  <div class="remote_container right" :class="noteArrow ? '' : 'hidden_remote_right'">
    <NoteArrow
        :noteArrowProps="noteArrow"
        @clickNoteArrowBtn="clickNoteArrowBtn"
    />
    <div id="visitNoteItemBox" class="item_box">
      <div class="item patient_name no-drag">
        <span>{{ patientTotalInfoProps.patientInfo.patientInfoName }}</span>
          {{' / '}}
        <span>
          {{ patientTotalInfoProps.patientInfo.patientInfoBirth ?
          $t('unit.man') + this.moment().diff(this.moment(patientTotalInfoProps.patientInfo.patientInfoBirth, 'YYYY-MM'), 'y') +
          $t('unit.years_old') : '-' }}
        </span>
      </div>
      <div class="item">
        <KvTable :items="getPatientInfo"/>
      </div>
      <div class="item">
        <h6 class="--blue70 mt10 mb10">{{ $t('patient.condition.condition') }}</h6>
        <KvTable :items="getPatientStatus"/>
      </div>
      <div class="item">
        <SelectedScheduleNote ref="selectedScheduleNote"
                              :noteProps="note"
                              :selectedScheduleProps="selectedScheduleProps"
                              :patientTotalInfoProps="patientTotalInfoProps"
                              :windowRefProps="windowRefProps"
        />
      </div>
      <div class="item">
        <a class="btn blue btn_basics pointer no-drag" @click="saveScheduleNote">
          {{ computedSaveStatus }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import KvTable from '@/components/Table/kvTable';
import NoteArrow from './noteArrow'
import SelectedScheduleNote from './selectedScheduleNote';
import {_MMT_GRADE_RANGE, _MRS_RANGE, _BRAIN_LESION_RANGE} from '@/components/Table/static';
import _API from "../../../../api";

export default {
  name : 'onlineVisitNote',
  props : ['patientTotalInfoProps', 'selectedScheduleProps', 'windowRefProps', 'noteArrow'],
  components : {KvTable, SelectedScheduleNote, NoteArrow},
  data() {
    const note = [
      {
        index: 0,
        keyTitle: '',
        keyType: 'TextArea',
        class: [],
        parentClass: '',
        values: this.selectedScheduleProps.scheduleNote,
        maxLength: 4095
      }
    ]
    return {
      note: note
    }
  },
  methods: {
    clickNoteArrowBtn(boolean) {
        this.$emit('onClickNoteArrowBtn', boolean);
    },
    saveScheduleNote() {
      if (this.selectedScheduleProps.scheduleNote === this.note[0].values) return
      const seqSchedule = this.selectedScheduleProps.seqSchedule;
      return new Promise((resolve, reject) => {
        _API.SCHEDULE.saveScheduleNoteBySeqSchedule({seqSchedule, scheduleNote: this.note[0].values})
            .then(({data}) => {
              if (data.isSuccess) {
                this.selectedScheduleProps.scheduleNote = this.note[0].values;
                resolve();
              } else {
                this.windowRefProps.alert(`${this.$t('alert.unexpected_error')}`);
                resolve();
              }
            })
            .catch(e => {
              if (String(e).startsWith('401')) {
                this.windowRefProps.alert(`${this.$t('alert.unexpected_error')}`);
              } else {
                this.windowRefProps?.close();
              }

              reject(`[saveScheduleNoteBySeqSchedule] ${e}`);
            });
      });
    }
  },
  computed: {
    getPatientInfo() {
      return [
        {
          index: 0,
          keyTitle: this.$t('patient.condition.primary_diagnosis'),
          keyType: 'Default',
          class: [],
          parentClass: '',
          keyRange: [],
          values: this.patientTotalInfoProps.patientInfo.patientInfoPrimaryDiagnosis || '-',
          mainStyle: {
            overflow: 'hidden',
            height: 'auto',
          }
        },
        {
          index: 1,
          keyTitle: this.$t('patient.condition.secondary_diagnosis'),
          keyType: 'Default',
          class: [],
          keyRange: [],
          values: this.patientTotalInfoProps.patientInfo.patientInfoSecondaryDiagnosis || '-',
          mainStyle: {
            overflow: 'hidden',
            height: 'auto',
          }
        },
        {
          index: 2,
          keyTitle: this.$t('patient.condition.on_set_date'),
          keyType: 'Default',
          class: [],
          keyRange: [],
          values: this.patientTotalInfoProps.patientInfo.patientInfoOccurrenceDate ?
              this.moment(this.patientTotalInfoProps.patientInfo.patientInfoOccurrenceDate).locale(this.$t('country')).format('ll') : '-'
        },
        {
          index: 3,
          keyTitle: this.$t('patient.condition.brain_lesions'),
          keyType: 'Default',
          class: [],
          keyRange: [],
          values: this.$t(_BRAIN_LESION_RANGE[this.patientTotalInfoProps.patientInfo.patientInfoBrainLesion]?.trans),
        }
      ];
    },
    getPatientStatus() {
      let strokeDuration = '';
      if (this.patientTotalInfoProps.patientInfo.patientInfoOccurrenceDate !== null) {
        const occurrenceDate = this.moment(this.patientTotalInfoProps.patientInfo.patientInfoOccurrenceDate);
        strokeDuration = this.moment().diff(occurrenceDate, "days");
      } else {
        strokeDuration = null;
      }

      let infection = this.patientTotalInfoProps.patientStatus.patientStatusInfection === 1 ? 'Y' : '-';
      infection = this.patientTotalInfoProps.patientStatus.patientStatusInfection !== 0 ? infection : 'N';

      return [
        {
          index: 0,
          keyTitle: this.$t('patient.condition.paralysis_part'),
          keyType: 'Default',
          class: [],
          parentClass: ['columns_1-2 custom-clamp'],
          keyRange: [],
          values: this.patientTotalInfoProps.patientStatus.patientStatusParalysisPart || '-'
        },
        {
          index: 2,
          keyTitle: this.$t('patient.condition.infection'),
          keyType: 'Default',
          class: [],
          parentClass: '',
          keyRange: [],
          values: infection,
        },
        {
          index: 3,
          keyTitle: this.$t('unit.MMT.name'),
          keyType: 'Default',
          keyOption: {
            tooltip: this.$t('unit.MMT.desc'),
          },
          class: [],
          parentClass: '',
          keyRange: [],
          values: this.patientTotalInfoProps.patientStatus.patientStatusMMT === '' ||
          this.patientTotalInfoProps.patientStatus.patientStatusMMT === undefined ||
          this.patientTotalInfoProps.patientStatus.patientStatusMMT === null
              ? 'N/A' : _MMT_GRADE_RANGE[Number(this.patientTotalInfoProps.patientStatus.patientStatusMMT) + 1].title
        },
        {
          index: 4,
          keyTitle: this.$t('unit.MRS.name'),
          keyType: 'Default',
          keyOption: {
            tooltip: this.$t('unit.MRS.desc'),
          },
          class: [],
          parentClass: '',
          keyRange: [],
          values: this.patientTotalInfoProps.patientStatus.patientStatusMRS === '' || this.patientTotalInfoProps.patientStatus.patientStatusMRS === undefined || this.patientTotalInfoProps.patientStatus.patientStatusMRS === null
              ? 'N/A' : _MRS_RANGE[Number(this.patientTotalInfoProps.patientStatus.patientStatusMRS) + 1].title
        },
        {
          index: 5,
          keyTitle: this.$t('patient.condition.onset_period'),
          keyType: 'Default',
          class: [],
          parentClass: '',
          keyRange: [],
          values: strokeDuration ? strokeDuration + this.$t('unit.days') : '-'
        },
        {
          index: 6,
          keyTitle: this.$t('patient.condition.medicine'),
          keyType: 'Default',
          class: [],
          parentClass: ['columns_3-4 custom-clamp'],
          keyRange: [],
          values: this.patientTotalInfoProps.patientStatus.patientStatusMedication ? this.patientTotalInfoProps.patientStatus.patientStatusMedication : '-'
        }
      ];
    },
    computedSaveStatus() {
      if (this.selectedScheduleProps.scheduleNote === this.note[0].values) {
        return this.$t('status.saved')
      } else {
        return this.$t('status.save')
      }
    }
  }
}
</script>
<style lang="scss">
.custom-clamp {
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    line-height: 20px;
  }
}
</style>